import { render, staticRenderFns } from "./CloseModal.vue?vue&type=template&id=2c778f44"
import script from "./CloseModal.vue?vue&type=script&lang=js"
export * from "./CloseModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports